import { Formik, FormikHelpers } from "formik";
import {
  ControlcenterMelcoModelsLicenseCreateResponse,
  useFormSubmit,
} from "melco-shared-logic";

import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { useQueryClient } from "react-query";
import { DisplayCreateLicenseForm } from "./DisplayCreateLicenseForm";
import { useState } from "react";
import { useLicenseManager } from "../../../hooks/licensemanager/useLicenseManager";

export type CreateLicenseFormValueType = {
  product_code: string;
  subscription_code: string;
  //referral_code: string;
  version_id: string; // will be use to create the License
  email_address: string;
  version_number?: string; // will be used to fetch subscriptions code that need product code and version number
  assign_license?: boolean;
  language?: string | null;
  melco_customer_id?: string | null;
  subscription_start_date?: Date | null;
  affiliate_code?: string | null
};

type CreateLicenseFormProps = {
  licenseFormValues?: CreateLicenseFormValueType;
  licenseDisplayValues: any;
  onCreateLicenseCallBackFn: (
    obj: CreateLicenseFormValueType,
    displayValues: any
  ) => any;
};

export const CreateLicenseForm: React.FC<CreateLicenseFormProps> = ({
  licenseDisplayValues,
  licenseFormValues,
  onCreateLicenseCallBackFn,
}) => {
  const queryClient = useQueryClient();
  const queryKey = "createlicensemanage";
  const licenseManager = useLicenseManager();
  const [displayValues, setDisplayValues] = useState<any>();
  const onSubmit = async (
    values: CreateLicenseFormValueType,
    formikHelpers: FormikHelpers<CreateLicenseFormValueType>
  ) => {
    await onCreateSerialNumber(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const createLicenseFormToInitialValues = (
    formvalues: CreateLicenseFormValueType
  ) => {
    const {
      email_address,
      version_number,
      version_id,
      product_code,
      subscription_code,
      assign_license,
      language,
      melco_customer_id,
      subscription_start_date,
      affiliate_code } = formvalues;

    const initialValues: CreateLicenseFormValueType = {
      product_code: product_code ?? "",
      subscription_code: subscription_code ?? "",
      version_number: version_number ?? "",
      version_id: version_id ?? "",
      email_address: email_address ?? "",
      assign_license: assign_license ?? false,
      language: language ?? "",
      melco_customer_id: melco_customer_id ?? "",
      subscription_start_date: subscription_start_date ?? null,
      affiliate_code: affiliate_code ?? ""
    };

    return initialValues;
  };

  const initialValues: CreateLicenseFormValueType = {
    product_code: licenseFormValues?.product_code ?? "",
    subscription_code: licenseFormValues?.subscription_code ?? "",
    version_number: licenseFormValues?.version_number ?? "",
    version_id: licenseFormValues?.version_id ?? "",
    email_address: licenseFormValues?.email_address ?? "",
    assign_license: licenseFormValues?.assign_license ?? false,
    language: licenseFormValues?.language ?? "",
    melco_customer_id: licenseFormValues?.melco_customer_id ?? "",
    subscription_start_date: licenseFormValues?.subscription_start_date ?? null,
    affiliate_code: licenseFormValues?.affiliate_code ?? ""
  };

  const handleCreateLicense = async (
    values: CreateLicenseFormValueType,
    formikHelpers: FormikHelpers<CreateLicenseFormValueType>,
    options: {}
  ) => {
    //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    /**
     * As per requirement by default we have to show Don't assign license switch button off in UI
     * but for backend we have to send true value for it.
     * so we will flip the value , whatever is shown in UI
     * if switch button off then send true
     * if switch button on then send false
     */
    let newEntity: ControlcenterMelcoModelsLicenseCreateResponse | undefined =
      await licenseManager({
        assign_license: !values.assign_license,
        email_address: values.email_address,

        product_code: values.product_code,
        referral_code: "LICENSE_MANAGER",
        subscription_code: values.subscription_code,
        version_id: values.version_id,
        is_validate_only: true,
        language: values.language,
        melco_customer_id: values.melco_customer_id,
        subscription_start_date: values.subscription_start_date,
        affiliate_code: values.affiliate_code
      });
    //   //console.log("newEntity",newEntity)
    console.log("[Debug] Subscription cost", newEntity?.subscription_cost);
    const updatedDisplayValues = {
      ...displayValues,
      subscription_cost: newEntity?.subscription_cost ?? 0,
      affiliate_name: newEntity?.affiliate_name ?? ""
    };
    setDisplayValues(updatedDisplayValues);

    // setDisplayValues((prevValues: any) => ({
    //   ...prevValues,
    //   subscription_cost: newEntity?.subscription_cost ?? 0,
    // }));
    console.log("ADD NEW ENTITy", newEntity);
    //let newEntity = null;
    formikHelpers.resetForm({
      values: createLicenseFormToInitialValues(
        newEntity
          ? {
            product_code: newEntity?.product_code ?? "",
            //"referral_code": "LICENSE_MANAGER",
            subscription_code: newEntity?.subscription_code ?? "",
            //  "version_number": newEntity?.version_number ?? "",
            version_id: newEntity?.version_id ?? "",
            email_address: newEntity?.email_address ?? "",
            //"assign_license": newEntity?.assign_license ?? true,
            language: newEntity?.language ?? "",
            melco_customer_id: newEntity?.melco_customer_id ?? "",
            subscription_start_date:
              newEntity?.subscription_start_date ?? null,
            affiliate_code: ""
          }
          : {
            product_code: "",
            //        "referral_code": "LICENSE_MANAGER",
            subscription_code: "",
            version_number: "",
            version_id: "",
            email_address: "",
            assign_license: false,
            language: "",
            melco_customer_id: "",
            subscription_start_date: null,
            affiliate_code: ""
          }
      ),
    });
    //queryClient.setQueryData(queryKey, newEntity);
    //onCloseDrawer(false);
    /**
     * Take original values so use values on summary page after click on Next button
     */
    let tempLicenseFormValues: CreateLicenseFormValueType = {
      email_address: values.email_address,
      product_code: values.product_code,
      subscription_code: values.subscription_code,
      version_id: values.version_id,
      version_number: displayValues?.version_number_label ?? "",
      assign_license: values?.assign_license,
      language: values?.language,
      melco_customer_id: values?.melco_customer_id,
      subscription_start_date: values?.subscription_start_date,
      affiliate_code: values?.affiliate_code
    };

    console.log("[debug] displayValues", updatedDisplayValues);
    onCreateLicenseCallBackFn(tempLicenseFormValues, updatedDisplayValues);
  };

  const formSubmitToCreateLicense = () => {
    return [
      async (
        values: CreateLicenseFormValueType,
        formikHelpers: FormikHelpers<CreateLicenseFormValueType>
      ) => {
        return handleCreateLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.Create",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licenses.basic.detail", "create"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onCreateSerialNumber = useFormSubmit(...formSubmitToCreateLicense());

  const callback = (v: any) => {
    console.log(v);
    setDisplayValues(v);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayCreateLicenseForm
            licenseFormValues={licenseFormValues}
            licenseDisplayValues={licenseDisplayValues}
            callback={callback}
          // onCloseDrawer={onCloseDrawer}
          />
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
